import { FC } from 'react'

import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { match } from 'ts-pattern'

import { CreditNoteRecordCard } from './records/creditNote/CreditNoteRecordCard'
import { CustomerRecordCard } from './records/customer/CustomerRecordCard'
import { PaymentRecordCard } from './records/payment/PaymentRecordCard'
import { QuoteRecordCard } from './records/quote/QuoteRecordCard'
import { SyncErrorTaskInput } from './types'

export const IntegrationSyncErrorRecordCard: FC<{ taskId: string }> = ({
  taskId
}) => {
  const { manualTask } = useManualTask({ taskId })
  const input = manualTask?.input as SyncErrorTaskInput | undefined

  if (!input) {
    return null
  }

  return match(input)
    .with({ entitySnapshot: { snapshotType: 'CUSTOMER' } }, () => (
      <CustomerRecordCard taskId={taskId} input={input} />
    ))
    .with(
      { entitySnapshot: { snapshotType: 'QUOTE' } },
      ({ entitySnapshot }) => (
        <QuoteRecordCard taskId={taskId} snapshot={entitySnapshot} />
      )
    )
    .with(
      { entitySnapshot: { snapshotType: 'CREDIT_NOTE' } },
      ({ entitySnapshot }) => (
        <CreditNoteRecordCard
          taskId={taskId}
          input={input}
          snapshot={entitySnapshot}
        />
      )
    )
    .with({ entityType: 'PAYMENT' }, () => (
      <PaymentRecordCard taskId={taskId} input={input} />
    ))
    .otherwise(() => null)
}
